export interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  publishedAt: string;
  readTime: number;
  viewCount: number;
  commentCount: number;
  imageUrl: string;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: "某知名互联网企业内部裁员黑幕：HR部门如何选择性优化员工",
    slug: "tech-company-layoff-insider",
    excerpt: "独家爆料：某头部互联网企业在最新一轮裁员中，HR部门通过操纵绩效考核数据，系统性清除高薪老员工，却以组织优化之名掩盖真相。多位前员工提供内部邮件与会议记录作为佐证。",
    content: `<p>近日，一位不愿透露姓名的前员工向我们提供了大量内部资料，揭露了某知名互联网企业在2025年底至2026年初进行的大规模裁员背后的真实操作手法。</p>
    <h3>绩效考核被操纵</h3>
    <p>据内部人士透露，HR部门在裁员前三个月就开始系统性调整员工绩效评分。原本表现优异的资深员工被刻意打低分，理由包括"不符合新业务方向""团队协作能力下降"等模糊评价。一位在该公司工作七年的技术专家表示："我连续三年绩效A+，但在第四季度突然被评定为C，没有任何具体解释。"</p>
    <p>内部流传的会议纪要显示，HR高层在一次闭门会议中明确提到"优化成本结构"的目标，要求各部门按照薪资水平从高到低列出可优化名单。这一做法被解读为变相逼退高薪老员工，为低成本新人让路。</p>
    <h3>补偿方案暗藏陷阱</h3>
    <p>公司对外宣传的N+3补偿方案看似优厚，但实际操作中存在大量限制条款。多位被裁员工反映，离职协议中包含严格的竞业限制条款和保密协议。更令人震惊的是，部分员工被要求在离职前签署"自愿离职"声明，以规避劳动仲裁风险。</p>
    <blockquote>"他们给你三天时间考虑，如果不签就威胁在背调时给差评。这不是选择，这是胁迫。"—— 一位前产品经理在匿名访谈中表示。</blockquote>
    <h3>监管真空下的灰色地带</h3>
    <p>法律专家指出，虽然劳动法对裁员有明确规定，但企业在实际操作中往往钻法律空子。通过操纵绩效数据、施加心理压力等手段，企业可以在不违反法律条文的前提下实现大规模减员。当前监管体系对这种灰色操作缺乏有效约束。</p>
    <p>本社区将持续关注此事进展，欢迎更多知情人士提供线索。</p>`,
    category: "企业内幕",
    categorySlug: "corporate-insider",
    author: "深度调查员",
    authorAvatar: "",
    publishedAt: "2026-08-06T14:30:00+08:00",
    readTime: 8,
    viewCount: 128600,
    commentCount: 2341,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20corporate%20office%20interior%20at%20night%20with%20empty%20desks%20and%20dim%20lighting%2C%20atmospheric%20cinematic%20photography%2C%20cold%20industrial%20aesthetic%2C%20mysterious%20and%20dramatic%20mood%2C%20high%20contrast%20shadows%2C%20professional%20editorial%20style%20with%20noir%20vibe&width=800&height=450&seq=article-1-hero&orientation=landscape",
    tags: ["裁员", "互联网", "HR黑幕", "绩效考核"],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 2,
    title: "金融圈最大庞氏骗局浮出水面：涉案金额或超500亿",
    slug: "financial-ponzi-scheme-exposed",
    excerpt: "一场持续五年的庞氏骗局正在被揭开。据知情人士透露，某私募基金通过虚假项目包装，累计吸收资金超500亿元，涉及投资人超3万人。目前监管部门已介入调查。",
    content: `<p>金融圈再次震动。一起规模空前的庞氏骗局正在被揭开面纱，涉案金额可能超过500亿元人民币，涉及投资人超过3万人。这可能是近年来国内最大规模的金融诈骗案之一。</p>
    <h3>精心包装的骗局</h3>
    <p>据了解，这家名为"XX资本"的私募基金自2021年起，通过包装一系列看似优质的投资项目吸引资金。项目涵盖新能源、芯片制造、生物医药等热门赛道，每个项目都有精美的PPT和看似详实的尽职调查报告。然而，这些项目中的大多数要么根本不存在，要么被严重夸大。</p>
    <h3>资金链断裂的导火索</h3>
    <p>2026年初，由于几个主要资金来源方要求赎回，资金池开始出现缺口。公司高管试图通过加快募集新资金来填补窟窿，但雪球越滚越大。今年6月，一位内部财务人员发现账目问题后匿名举报，引发监管介入。</p>
    <p>目前已有超过200名投资人联合报案，多地公安机关已立案侦查。涉案的多名高管已被限制出境。</p>`,
    category: "金融黑幕",
    categorySlug: "financial-scandal",
    author: "金融观察员",
    authorAvatar: "",
    publishedAt: "2026-08-05T10:00:00+08:00",
    readTime: 6,
    viewCount: 312000,
    commentCount: 4567,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20luxury%20financial%20office%20with%20scattered%20documents%20and%20money%20on%20desk%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20cinematic%20noir%20atmosphere%2C%20cold%20and%20tense%20mood%2C%20editorial%20investigative%20journalism%20photography&width=800&height=450&seq=article-2-hero&orientation=landscape",
    tags: ["庞氏骗局", "金融诈骗", "私募基金", "监管"],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 3,
    title: "娱乐圈顶级流量明星背后的资本运作链条全揭秘",
    slug: "entertainment-capital-chain",
    excerpt: "你以为的顶流明星是靠才华走红？真相是：资本方通过数据造假、热搜操控、饭圈运营等手段，可以批量制造顶流。我们获得了内部运营手册，揭露这条灰色产业链。",
    content: `<p>在流量为王的时代，顶流明星的诞生真的靠才华和运气吗？本社区独家获取了一份某娱乐营销公司的内部运营手册，揭示了一条成熟的数据造假与流量操控产业链。</p>
    <h3>三步造星流水线</h3>
    <p>第一步：数据基建。新人在出道前三个月，团队就开始铺设基础数据——微博粉丝量、超话签到、百度指数等，通过技术手段批量生成。一个新人从零到百万粉丝，只需要两周时间。</p>
    <p>第二步：热点制造。通过与营销号合作、购买热搜位、策划争议话题等方式，在短时间内制造高密度曝光。内部手册显示，一次完整的"热搜套餐"费用约为80-150万元。</p>
    <p>第三步：饭圈运营。职业粉丝（职粉）负责管理粉丝社群，引导舆论方向，组织打投活动。职粉团队按照标准化流程运营，确保粉丝始终保持高活跃度和消费意愿。</p>
    <h3>谁在买单？</h3>
    <p>最终买单的是品牌方和普通粉丝。品牌方看到的流量数据大部分是虚假的，粉丝看到的互动热度是人造的，而真正的赢家是背后的资本运作方。</p>`,
    category: "娱乐揭秘",
    categorySlug: "entertainment-expose",
    author: "圈内老炮",
    authorAvatar: "",
    publishedAt: "2026-08-04T16:00:00+08:00",
    readTime: 7,
    viewCount: 256000,
    commentCount: 3210,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20stage%20with%20spotlight%20and%20shadow%20silhouette%2C%20dramatic%20theatrical%20atmosphere%2C%20mysterious%20backstage%20vibe%2C%20cinematic%20lighting%20with%20puppet%20strings%20metaphor%2C%20high%20contrast%20noir%20photography&width=800&height=450&seq=article-3-hero&orientation=landscape",
    tags: ["娱乐圈", "流量造假", "资本运作", "饭圈"],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 4,
    title: "某地房地产商与地方官员利益输送链条深度调查",
    slug: "real-estate-corruption-chain",
    excerpt: "历时三个月的调查，我们追踪到某二线城市多个房地产项目背后存在的权钱交易网络。从土地出让到项目审批，每个环节都暗藏灰色利益输送。",
    content: `<p>房地产市场表面风平浪静，水下暗流涌动。本社区调查团队历时三个月，深入某二线城市，揭开了一条横跨土地出让、规划审批、预售许可等多个环节的利益输送链条。</p>
    <h3>土地出让的猫腻</h3>
    <p>调查发现，该市2024-2025年出让的多个热门地块，最终得主多为同一集团旗下的不同子公司。公开竞拍看似合规，但竞拍规则中的"特殊条件"实际上已经排除了绝大多数竞争者。业内人士透露，这些特殊条件往往是为特定企业量身定制的。</p>
    <h3>规划审批的绿色通道</h3>
    <p>更令人关注的是，这些项目在规划审批环节享受了明显的便利。容积率调整、用途变更等通常需要数月审批的流程，相关项目在数周内即可完成。多位业内人士暗示，这与项目方与审批部门之间的特殊关系密切相关。</p>`,
    category: "政商关系",
    categorySlug: "politics-business",
    author: "调查记者团",
    authorAvatar: "",
    publishedAt: "2026-08-03T09:00:00+08:00",
    readTime: 9,
    viewCount: 189000,
    commentCount: 2789,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20architectural%20model%20of%20buildings%20with%20shadows%20and%20hidden%20compartments%2C%20metaphorical%20corruption%20theme%2C%20dramatic%20noir%20lighting%2C%20mysterious%20and%20tense%20atmosphere%2C%20editorial%20photography%20with%20deep%20contrast&width=800&height=450&seq=article-4-hero&orientation=landscape",
    tags: ["房地产", "腐败", "利益输送", "土地出让"],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 5,
    title: "食品安全再爆雷：知名连锁餐饮后厨真相触目惊心",
    slug: "food-safety-chain-restaurant",
    excerpt: "卧底调查员在某全国连锁餐饮品牌后厨工作一个月，拍下了过期食材翻新、回收油重复使用、卫生条件极其恶劣等令人震惊的画面。",
    content: `<p>当你坐在装修精致的餐厅里享用美食时，后厨正在发生什么？本社区卧底调查员在某全国连锁餐饮品牌的后厨工作一个月，记录下了触目惊心的真相。</p>
    <h3>过期食材的障眼法</h3>
    <p>卧底发现，该餐厅对于过期食材的处理方式令人发指。临近保质期的肉类通过重口味腌制掩盖异味后继续使用；过期面包重新烘烤后充当新鲜出品；蔬菜腐烂部分切除后剩余部分照常上桌。后厨主管甚至总结了"过期食材处理十二法"来指导员工操作。</p>
    <h3>回收油的秘密</h3>
    <p>炸制食品使用的油在变黑发稠后并不更换，而是通过滤网简单过滤后继续使用。卧底录制的视频显示，炸油颜色已呈深褐色，但仍被用于炸制鸡翅、薯条等畅销产品。</p>`,
    category: "社会民生",
    categorySlug: "society-livelihood",
    author: "卧底调查员",
    authorAvatar: "",
    publishedAt: "2026-08-02T11:00:00+08:00",
    readTime: 7,
    viewCount: 375000,
    commentCount: 5678,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20grimy%20restaurant%20kitchen%20with%20dim%20lighting%2C%20dirty%20surfaces%20and%20cluttered%20workspace%2C%20atmospheric%20investigative%20journalism%20style%2C%20high%20contrast%20shadows%2C%20noir%20documentary%20photography%20with%20tense%20mood&width=800&height=450&seq=article-5-hero&orientation=landscape",
    tags: ["食品安全", "连锁餐饮", "卧底调查", "后厨"],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 6,
    title: "高考移民产业链曝光：从户籍造假到学籍运作全流程",
    slug: "college-entrance-exam-migration",
    excerpt: "每年高考季，一条隐秘的高考移民产业链都在暗流涌动。从伪造户籍到运作学籍，从中介牵线到学校配合，我们揭开了这条灰色产业链的完整运作模式。",
    content: `<p>高考公平是社会公平的重要底线，但一条运作成熟的"高考移民"产业链正在侵蚀这条底线。本社区调查发现，从户籍办理到学籍转移，每个环节都有专业团队提供服务。</p>
    <h3>全套服务的价格表</h3>
    <p>调查获得的内部报价显示，高考移民服务根据目的省份的录取优势分为不同档次。热门省份如青海、宁夏、新疆等地的全套服务费用在15-30万元不等，包括户籍办理、学籍转移、租房证明、社保代缴等一系列手续。</p>
    <h3>灰色地带的操盘手</h3>
    <p>操盘这条产业链的是一批专业的"教育咨询公司"，他们与多地户籍管理部门的内部人员建立了长期合作关系。在学籍方面，部分民办学校甚至主动参与其中，以额外收费的方式接收高考移民学生。</p>`,
    category: "社会民生",
    categorySlug: "society-livelihood",
    author: "教育观察者",
    authorAvatar: "",
    publishedAt: "2026-08-01T08:00:00+08:00",
    readTime: 6,
    viewCount: 142000,
    commentCount: 1890,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20empty%20classroom%20with%20exam%20papers%20scattered%2C%20dramatic%20shadows%20through%20window%20blinds%2C%20atmospheric%20and%20tense%20mood%2C%20cinematic%20noir%20style%2C%20editorial%20investigative%20photography&width=800&height=450&seq=article-6-hero&orientation=landscape",
    tags: ["高考移民", "教育公平", "户籍造假", "灰色产业"],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 7,
    title: "医美行业暴利内幕：千元成本的项目如何卖出十万元",
    slug: "cosmetic-surgery-profit-exposed",
    excerpt: "一支玻尿酸的成本不到200元，到消费者手中却要支付8000元。医美行业的暴利程度远超想象。我们对话了三位从医美行业离职的从业者，揭露行业定价黑幕。",
    content: `<p>医美行业的暴利早已不是秘密，但暴利到什么程度？本社区对话了三位从不同医美机构离职的前从业者，他们提供的数据令人震惊。</p>
    <h3>成本与定价的惊人差距</h3>
    <p>以最常见的玻尿酸注射为例，正规渠道采购的玻尿酸单支成本在150-300元之间。但在终端，消费者需要支付5000-12000元不等。加价倍率高达30-80倍。从业者透露，这还不包括以次充好的情况，部分机构使用成本仅几十元的无资质产品冒充进口正品。</p>
    <h3>营销成本转嫁消费者</h3>
    <p>医美机构最大的支出并非产品成本，而是营销获客成本。据透露，一些头部机构在社交媒体和搜索引擎上的月投放费用高达数百万元。这些营销成本最终全部转嫁到消费者身上。</p>`,
    category: "消费陷阱",
    categorySlug: "consumer-trap",
    author: "消费侦探",
    authorAvatar: "",
    publishedAt: "2026-07-31T14:00:00+08:00",
    readTime: 5,
    viewCount: 203000,
    commentCount: 3421,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20clinical%20aesthetic%20room%20with%20medical%20equipment%20and%20dramatic%20lighting%2C%20cold%20sterile%20atmosphere%2C%20mysterious%20shadows%2C%20cinematic%20noir%20photography%2C%20editorial%20style%20with%20high%20contrast&width=800&height=450&seq=article-7-hero&orientation=landscape",
    tags: ["医美", "暴利", "消费陷阱", "玻尿酸"],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 8,
    title: "跨国电信诈骗集团组织架构大起底：从话术到洗钱的完整链条",
    slug: "telecom-fraud-organization-exposed",
    excerpt: "一份来自东南亚某国执法部门的内部报告流出，详细记录了跨国电信诈骗集团的金字塔式组织架构、话术培训体系和资金流转路径。",
    content: `<p>电信诈骗已成为全球性问题。本社区独家获得了一份来自东南亚某国执法部门的内部报告，首次完整揭示了跨国电信诈骗集团的运作全貌。</p>
    <h3>金字塔式管理</h3>
    <p>报告显示，大型诈骗集团采用公司化管理模式。顶层是投资人和决策层，负责资金支持和战略方向；中层是技术和管理团队，负责系统搭建、话术开发和人员培训；底层是一线话务员，负责具体实施诈骗。</p>
    <h3>话术工厂的流水线</h3>
    <p>诈骗话术经过系统性研发和迭代，根据不同目标人群定制不同剧本。报告收录了超过20套完整话术脚本，从冒充公检法到虚假投资理财，从感情诈骗到刷单返利，覆盖了所有主流诈骗类型。</p>`,
    category: "犯罪揭秘",
    categorySlug: "crime-expose",
    author: "国际调查组",
    authorAvatar: "",
    publishedAt: "2026-07-30T10:00:00+08:00",
    readTime: 8,
    viewCount: 298000,
    commentCount: 4120,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20room%20filled%20with%20computer%20screens%20and%20headsets%2C%20underground%20call%20center%20atmosphere%2C%20dramatic%20moody%20lighting%2C%20cinematic%20thriller%20style%2C%20high%20contrast%20noir%20photography%20with%20cold%20tones&width=800&height=450&seq=article-8-hero&orientation=landscape",
    tags: ["电信诈骗", "跨国犯罪", "洗钱", "话术"],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 9,
    title: "学术论文代写产业链：从本科到博士的全覆盖灰色服务",
    slug: "academic-ghostwriting-industry",
    excerpt: "每到毕业季，一条隐藏的学术论文代写产业链便进入业务高峰期。从本科毕业论文到博士SCI论文，从中文普刊到国际顶刊，都有明码标价的代写服务。",
    content: `<p>学术诚信正在遭受前所未有的挑战。本社区调查发现，学术论文代写已经发展成为一个规模庞大的地下产业，形成了从写手招募到客户获客的完整闭环。</p>
    <h3>明码标价的学术服务</h3>
    <p>调查获得的报价单显示：本科毕业论文5000-15000元，硕士论文20000-50000元，博士论文80000-200000元，SCI论文代写代发50000-300000元不等。价格根据学科、字数、时间要求和发表的期刊等级而定。</p>
    <h3>专业化的代写团队</h3>
    <p>这些代写机构拥有专业的写手团队，包括研究生、高校青年教师甚至一些副教授级别的写手。高端论文通常由具有相关专业背景的博士或高校教师撰写，以保证论文质量。</p>`,
    category: "教育黑幕",
    categorySlug: "education-scandal",
    author: "学术监察员",
    authorAvatar: "",
    publishedAt: "2026-07-29T15:00:00+08:00",
    readTime: 6,
    viewCount: 167000,
    commentCount: 2340,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20library%20with%20stacked%20papers%20and%20dim%20desk%20lamp%2C%20academic%20atmosphere%20with%20shadows%2C%20mysterious%20and%20dramatic%20mood%2C%20cinematic%20noir%20photography%2C%20editorial%20style%20with%20high%20contrast&width=800&height=450&seq=article-9-hero&orientation=landscape",
    tags: ["学术造假", "论文代写", "教育", "灰色产业"],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 10,
    title: "二手平台奢侈品造假链条：从高仿工厂到平台包庇的完整通路",
    slug: "secondhand-luxury-counterfeit-chain",
    excerpt: "你在二手平台买的奢侈品可能是假的。调查发现，一条从高仿工厂直达二手平台的造假链条已经成熟运作多年，而平台的鉴定服务形同虚设。",
    content: `<p>以为在二手平台捡到宝？你可能正在购买一件高仿假货。本社区调查发现，二手奢侈品平台的造假问题远比想象中严重。</p>
    <h3>高仿工厂的工艺升级</h3>
    <p>国内一些高仿工厂的工艺水平已经达到以假乱真的程度。从皮料选择到五金配件，从缝线工艺到防伪标识，高仿包的每一个细节都精准复刻正品。业内人士透露，A+级别的高仿包出厂价在500-2000元，经过二手平台鉴定后，可以卖出数倍甚至数十倍的价格。</p>
    <h3>平台鉴定的形同虚设</h3>
    <p>调查发现，部分二手平台的鉴定流程存在严重漏洞。有些高仿卖家与平台鉴定师存在利益关联，通过贿赂方式获得真品鉴定报告。更有甚者，部分平台默许高仿商品在其平台上流通，因为无论真假，平台都能从中抽取交易佣金。</p>`,
    category: "消费陷阱",
    categorySlug: "consumer-trap",
    author: "消费侦探",
    authorAvatar: "",
    publishedAt: "2026-07-28T12:00:00+08:00",
    readTime: 6,
    viewCount: 234000,
    commentCount: 3890,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20luxury%20handbags%20displayed%20in%20shadow%2C%20counterfeit%20goods%20theme%2C%20dramatic%20lighting%20with%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20editorial%20investigative%20photography&width=800&height=450&seq=article-10-hero&orientation=landscape",
    tags: ["二手奢侈品", "高仿", "平台责任", "消费维权"],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 11,
    title: "在线教育平台数据造假内幕：90%的完课率是如何编造出来的",
    slug: "online-education-data-fraud",
    excerpt: "多家头部在线教育平台被曝系统性数据造假。所谓的学员满意度、完课率、就业率等核心指标，大部分都是通过技术手段和激励政策人为制造出来的。",
    content: `<p>在线教育行业的数据泡沫终于被戳破。本社区获得多位前在线教育平台员工的证词，揭示了行业内普遍存在的数据造假手段。</p>
    <h3>完课率的数字游戏</h3>
    <p>某头部平台宣传的90%完课率是如何做到的？内部人士透露：系统会自动将所有点开过课程页面的用户计为完课，无论其实际观看时长是多少。即使是仅仅进入了课程页面就退出的用户，也会被统计在内。</p>
    <h3>就业率的包装术</h3>
    <p>就业率是在线教育平台最重要的营销卖点之一。实际做法是：将找到任何工作的学员都计为就业成功，不管其工作是否与培训内容相关。部分平台甚至将学员培训后从事外卖、快递等灵活就业也纳入就业统计。</p>`,
    category: "消费陷阱",
    categorySlug: "consumer-trap",
    author: "教育观察者",
    authorAvatar: "",
    publishedAt: "2026-07-27T09:00:00+08:00",
    readTime: 5,
    viewCount: 178000,
    commentCount: 2678,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20modern%20classroom%20with%20computer%20screens%20showing%20fake%20data%20charts%2C%20dramatic%20shadows%2C%20cold%20digital%20atmosphere%2C%20cinematic%20noir%20style%2C%20editorial%20investigative%20photography%20with%20high%20contrast&width=800&height=450&seq=article-11-hero&orientation=landscape",
    tags: ["在线教育", "数据造假", "完课率", "行业黑幕"],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 12,
    title: "地下现金贷死灰复燃：年化利率2000%的超利贷如何逃避监管",
    slug: "underground-cash-loan-revival",
    excerpt: "在监管严厉打击之后，地下现金贷以更隐蔽的方式卷土重来。通过社交群组、海外服务器和虚拟货币结算，一条年化利率超2000%的超利贷链条正在野蛮生长。",
    content: `<p>尽管监管层多次出手打击，地下现金贷依然以更加隐蔽的方式存在。本社区调查发现，通过利用社交群组运营、海外服务器和虚拟货币结算等手段，超利贷市场正在经历新一轮野蛮生长。</p>
    <h3>隐蔽的获客渠道</h3>
    <p>如今的地下现金贷已经完全转入地下运营。他们通过微信群、QQ群、Telegram等社交平台进行获客和放款。一旦用户加入群组，就会被拉入私聊，完成身份验证后通过虚拟货币或第三方支付的小额转账发放贷款。</p>
    <h3>惊人的利率和催收手段</h3>
    <p>调查获得的借款合同显示，这些超利贷的借款周期通常为7天，年化利率高达2000%以上。借款人借1000元实际到账700元，7天后需还款1100元。逾期后，催收人员会通过借款人授权时获取的通讯录信息，对其亲友进行骚扰催收。</p>`,
    category: "金融黑幕",
    categorySlug: "financial-scandal",
    author: "金融观察员",
    authorAvatar: "",
    publishedAt: "2026-07-26T16:00:00+08:00",
    readTime: 7,
    viewCount: 287000,
    commentCount: 4532,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20alley%20with%20money%20exchange%20hands%20in%20shadow%2C%20underground%20financial%20deal%2C%20dramatic%20noir%20lighting%2C%20mysterious%20and%20dangerous%20atmosphere%2C%20cinematic%20photography%20with%20high%20contrast&width=800&height=450&seq=article-12-hero&orientation=landscape",
    tags: ["现金贷", "超利贷", "金融监管", "催收"],
    isHot: false,
    isExclusive: true,
  },
];